import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '../../../../core/Button/Button.jsx';

function FinishedTournamentButton({ desktopRequire = false }) {
    const { t } = useTranslation();
    const isMobile = useSelector((state) => state.user.isMobile);

    const button = (
        <div className="button-size">
            <Button
                type="lightblue"
                text={t('tournament.finished')}
                onClick={() => {}}
            />
        </div>
    );

    if (desktopRequire || !isMobile) {
        return button;
    }

    return <i className="icon-information" />;
}

export default FinishedTournamentButton;
